<template>
  <div class="row">
    <Header
      :AvailableLengths="AvailableLengths"
      :unAvailableLengths="unAvailableLengths"
      :totalRows="totalRows"
      :search_term="search_term"
      @setValue="setValue"
      @search="search"
      :selected_view="selected_view"
      :fields="fields"
      @selectView="selectView"
      @selectField="selectField"
      @resetFieldSelection="resetFieldSelection"
      @quickSearch="quickSearch"
      @groupByKey="groupByKey"
      @showDownloadFilters="showDownloadFiltersMenu"      
    />
    <drivers-table
      ref="DriversTable"
      @getAvailableLengths="getAvailableLengthsData"
      @resetQuickSearchPayload="reset"
      :selected_view="selected_view"
      :fields="fields"
      :showDownloadFilters="showDownloadFilters"
      @resetSearch="resetShowDownloadFilters"
    />
  </div>
</template>

<script>
import DriversTable from "./DriversTable.vue";
import Header from "./Header.vue";
import { nanoid } from "nanoid";

export default {
  components: {
    DriversTable,
    Header,
  },
  data() {
    return {
      AvailableLengths: null,
      unAvailableLengths: null,
      totalRows: null,
      search_term: null,
      showDownloadFilters:false,
      fields: [
        {
          key: "employeeID",
          label: this.$t("employee-id"),
          sortable: false,
          class: "align-middle",
          selected: true,
        },
        {
          key: "provider",
          label: this.$t("source"),
          class: "align-middle",
          selected: true,
        },
        {
          key: "garage",
          label: this.$t("garage"),
          sortable: false,
          class: "align-middle",
          selected: true,
        },
        {
          key: "name",
          label: this.$t("name-in-english"),
          class: "align-middle",
          selected: true,
        },
        {
          key: "arabicName",
          label: this.$t("name-in-arabic"),
          class: "align-middle",
          selected: true,
        },
        {
          key: "mobileNumber",
          label: this.$t("mobile-number"),
          class: "align-middle",
          sortable: false,
          selected: true,
        },
        {
          key: "active",
          label: this.$t("status"),
          sortable: false,
          class: "align-middle",
          selected: true,
        },
        {
          key: "rating",
          label: this.$t("rating"),
          sortable: false,
          class: "align-middle",
          thStyle: { paddingRight: "15px !important" },
          selected: true,
        },
        {
          key: "assigned_vehicle",
          label: this.$t("assigned-vehicle"),
          sortable: false,
          class: "driver-tdClass text-start align-middle",
          selected: true,
        },
        {
          key: "action",
          label: this.$t("action"),
          sortable: false,
          class: "align-middle",
          selected: true,
        },
      ],
      selected_view: this.$route?.query?.view || "table",
    };
  },
  methods: {
    setValue(val, field) {
      this[field] = val;
      this.$refs["DriversTable"].searchPayload.employee_id = val;
    },
    search() {
      this.$refs["DriversTable"].filterBySideBar();
    },
    reset() {
      this.search_term = null;
    },
    getAvailableLengthsData(availableLengths, unAvailableLengths, totalRows) {
      this.AvailableLengths = availableLengths;
      this.unAvailableLengths = unAvailableLengths;
      this.totalRows = totalRows;
    },
    selectView(view) {
      this.selected_view = view;
      this.$router.replace({ query: { view: view } }).catch(() => {});
    },
    selectField(option) {
      if (
        (this.fields.filter((each) => each.selected).length > 1 &&
          option.selected) ||
        !option.selected
      )
        this.fields = this.fields?.map((each) => {
          if (each.key === option.key) each.selected = !each.selected;
          return each;
        });
    },
    resetFieldSelection() {
      this.fields = this.fields?.map((each) => {
        each.selected = true;
        return each;
      });
    },
    quickSearch(key, value) {
      this.$refs["DriversTable"].quickSearch(key, value);
    },
    groupByKey(key) {
      this.$refs["DriversTable"].groupByKey(key);
    },
    showDownloadFiltersMenu() {
      this.showDownloadFilters = nanoid();
    },
    resetShowDownloadFilters() {
      this.showDownloadFilters = false;
    },
  },
};
</script>
